export const CreditService = Symbol('CreditService');

/**
 * 积分（点数）服务
 */
export interface CreditService {
    /**
     * 同步积分（点数）使用情况
     */
    syncCreditUsage(): Promise<void>;
}
